/**
 * An exception that occurs when the implementation of a routine was not yet completed.
 */
export class NotImplementedError extends Error {
  constructor() {
    super("Not yet implemented.");
  }
}
